// src/pages/About/About.js
import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page page-content">
      <section className="page-banner">
        <div className="container">
          <h1>About Vista Elevations</h1>
          <p>Your Trusted Technology Partner</p>
        </div>
      </section>

      <section className="who-we-are">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2>Who We Are</h2>
              <div className="title-line"></div>
              <p>
                At Vista Elevations Pvt. Ltd, we are more than just an IT solutions provider—we are your 
                trusted technology partner. Founded in 2024, we aim to bridge the gap between business 
                challenges and innovative digital solutions.
              </p>
              <p>
                Our expertise spans IT infrastructure, cloud, software development, data analytics, and 
                enterprise mobility solutions, helping businesses adapt, transform, and thrive in the digital world.
              </p>
            </div>
            <div className="content-image">
              <div className="image-box">
                <span className="icon">🏢</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vision-mission">
        <div className="container">
          <div className="vm-grid">
            <div className="vm-card">
              <div className="vm-icon">🎯</div>
              <h3>Our Vision</h3>
              <p>
                To be a pioneering force in IT solutions, where cutting-edge technology meets innovation 
                to accelerate business success. We are committed to empowering organizations through advanced 
                digital transformation.
              </p>
            </div>
            <div className="vm-card">
              <div className="vm-icon">🚀</div>
              <h3>Our Mission</h3>
              <ul>
                <li>Deliver cutting-edge IT solutions tailored to business needs</li>
                <li>Foster innovation and drive digital transformation</li>
                <li>Empower businesses with data-driven decision-making</li>
                <li>Create a collaborative and technology-driven ecosystem</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="objective-section">
        <div className="container">
          <h2>Our Objective</h2>
          <div className="title-line centered"></div>
          <p>
            We are here to simplify technology for businesses. Our goal is to enable seamless digital 
            transformation by delivering scalable, secure, and cost-effective IT solutions.
          </p>
        </div>
      </section>

      <section className="values-section">
        <div className="container">
          <h2>Why Choose Us?</h2>
          <div className="title-line centered"></div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">💡</div>
              <h3>Innovation</h3>
              <p>Cutting-edge solutions using latest technologies</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Partnership</h3>
              <p>We work as your technology partner</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h3>Results</h3>
              <p>Focused on measurable business outcomes</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🔒</div>
              <h3>Security</h3>
              <p>Enterprise-grade security in all solutions</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;